// extracted by mini-css-extract-plugin
module.exports = {"accent":"#5BC4A6"};